"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require('./perfect-scrollbar.component'));
__export(require('./perfect-scrollbar.directive'));
__export(require('./perfect-scrollbar.interfaces'));
__export(require('./perfect-scrollbar.module'));



//////////////////
// WEBPACK FOOTER
// ./~/angular2-perfect-scrollbar/dist/lib/index.js
// module id = 36
// module chunks = 0 1